import { ConfigurationParameterService, ConfigurationParameter } from '@/modules/configurationModule/detail/parameters/models/configuration-parameters.model'
import { ConfigurationParameterGroupResponse, ConfigurationParameterPatchInBatchRequest } from '@/modules/configurationModule/detail/parameters/services/configuration-parameters.dto'
import { Nullable } from '@/shared/types/app.types'
import { store } from '@/store/store'

export interface SideBar {
    id: number
    label: string
    icon: string
    routeName: string
    routeParams: { [key: string]: any }
    selected: boolean
    hasChildren: boolean
}

export interface SideBarData {
    id: string
    title: string
    sidebar: SideBar[]
}

export interface ConfigurationParameterFormState {
    service: Nullable<ConfigurationParameterService>
    groupId: number
    laboratoryId: number
    parametersGroups: ConfigurationParameterGroupResponse[]
    parameterGroup: Nullable<ConfigurationParameterGroupResponse>
    parameters: ConfigurationParameter[]
    changes: ConfigurationParameterPatchInBatchRequest[]
}
export const initialConfigurationParameterFormState =
    (groupId: number): ConfigurationParameterFormState => ({
        service: null,
        groupId,
        laboratoryId: store.getters.labId,
        parametersGroups: [],
        parameterGroup: null,
        parameters: [],
        changes: []
    })
